import { AsurionLogoDark } from "@expert/common-ui/assets/AsurionLogoDark";
import { Box, Container } from "@mantine/core";

import type { BotIconProps } from "./types";

import classes from "./BotIcon.module.css";
import BubbleLoader from "./BubbleLoader";
import { BotIconWrapper, LogoWrapper } from "./elements";

export function BotIcon({ isLoading, isHidden, isBotListening }: BotIconProps) {
    return (
        <BotIconWrapper data-testid="bot-icon-wrapper">
            {!isHidden && (
                <>
                    <LogoWrapper data-testid="logo-wrapper">
                        <Container className={classes.loaderLogo}>
                            <Box style={{ transform: "scale(0.8)" }}>
                                <AsurionLogoDark />
                            </Box>
                        </Container>
                    </LogoWrapper>

                    <BubbleLoader
                        className={`${classes.styledBubbleLoader} ${isBotListening ? classes.listeningBubbles : ""}`}
                        isBotListening={isBotListening}
                        isLoading={isLoading}
                    />
                </>
            )}
        </BotIconWrapper>
    );
}
export default BotIcon;
